/**
 * Tuition Table Embeds
 * -----------------------------------------------------------------------------
 *
 * Notes
 * 1. `tuition_table` is a Module ID used by the build and will point to the
 *    Tuition Table script once the main JS file is bundled.
 */

// Imports
const { ALERT_MESSAGES } = require( '../utilities/_constants' );



const hasTuitionTables = !!document.querySelectorAll( '.tuition-table' ).length;

if ( hasTuitionTables ) {

  try {

    /* 1 */
    import( 'tuition_table' )
      .catch( ( e ) => console.log( e ) );

  } catch( e ) {
    alert( ALERT_MESSAGES.DYNAMIC_IMPORTS );
  }

}
